import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-[var(--screen-min-width)] items-center gap-2 rounded-3xl p-2 shadow-[1px_1px_12px_4px_rgba(0,0,0,0.1)]',
    icon: 'mb-auto flex size-8 min-w-8 items-center justify-center rounded-full border border-white text-white',
    message: 'heading-text-s-mold pr-2 text-white'
  },
  variants: {
    status: {
      success: 'bg-label-green',
      error: 'bg-label-red'
    }
  },
  defaultVariants: {
    status: 'success'
  }
});
